import { delegateInit } from './BaseShape';
import { ConditionRhombus } from './ConditionRhombus';

const ENTITY_FIELD_NAME = 'SwitchStatement';

export default delegateInit(ConditionRhombus, ENTITY_FIELD_NAME);



// WEBPACK FOOTER //
// ./src/render/svg/shapes/SwitchStatement.js